module.exports = __webpack_public_path__ + "static/media/Lens-Vivid Style_diameter.6582f5b8.png";